import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { IncomingInvoiceSendBackFormViewProps } from "models/propTypes/incomingInvoicePropTypes";
import { FormEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const IncomingInvoiceSendBackForm: ForwardRefRenderFunction<FormHandles, IncomingInvoiceSendBackFormViewProps> = (
  props,
  ref
) => {
  return (
    <GenericForm<IncomingInvoiceFormTypes.SendBack>
      formRef={ref}
      {...props}
      fields={{
        email: {
          label: TranslationKeys.Common.Email,
          type: FormEnums.FormFieldType.EMAIL,
          icon: IconDefinitionConstants.WUser,
          descriptionText: TranslationKeys.IncomingInvoice.SendBackEmailHelpText,
          widthColumnCount: 7,
        },
        subject: {
          label: TranslationKeys.Common.Subject,
          type: FormEnums.FormFieldType.TEXT,
          descriptionText: TranslationKeys.IncomingInvoice.SendBackSubjectHelpText,
          icon: IconDefinitionConstants.WTag,
        },
        message: {
          label: TranslationKeys.Common.ReturnWhy,
          type: FormEnums.FormFieldType.TEXTAREA,
          descriptionText: TranslationKeys.IncomingInvoice.SendBackMessageHelpText,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
      hideSuccess
    />
  );
};

export default forwardRef(IncomingInvoiceSendBackForm);
